module.exports = "<div class=\"text-center\">\r\n    <div class=\"title-container\">\r\n        <h1 class=\"review-overview-title title header--color-secondary\">{{title}}</h1>\r\n    </div>\r\n    <div ng-show=\"!hasReviews()\">\r\n        <div class=\"title-container\">\r\n            <h2 class=\"review-overview-subtitle title--type-2 header--color-secondary\">{{zeroResultsMessage}}</h2>\r\n        </div>\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/customer-reviews/headings/standard-heading-template.html
 ** module id = 920
 ** module chunks = 1
 **/